import type { TFunction } from "i18next";

/** English sector strings from API / filters — map to `pages.topHalal.sectors.*` keys. */
export const TOP_HALAL_SECTOR_EN_TO_I18N: Record<string, string> = {
  "Basic Materials": "basicMaterials",
  "Communication Services": "communicationServices",
  "Consumer Cyclical": "consumerCyclical",
  "Consumer Defensive": "consumerDefensive",
  Energy: "energy",
  "Financial Services": "financialServices",
  Healthcare: "healthcare",
  Industrials: "industrials",
  "Real Estate": "realEstate",
  Technology: "technology",
  Utilities: "utilities",
};

export const TOP_HALAL_SECTOR_FILTER_ORDER = [
  "all",
  "Basic Materials",
  "Communication Services",
  "Consumer Cyclical",
  "Consumer Defensive",
  "Energy",
  "Financial Services",
  "Healthcare",
  "Industrials",
  "Real Estate",
  "Technology",
  "Utilities",
] as const;

export function translateTopHalalSectorName(
  englishName: string | undefined | null,
  t: TFunction,
): string {
  if (!englishName || englishName === "-") return "-";
  const trimmed = englishName.trim();
  const key = TOP_HALAL_SECTOR_EN_TO_I18N[trimmed];
  if (key) {
    return String(t(`pages.topHalal.sectors.${key}`));
  }
  return trimmed;
}
